import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ErrorHelper } from '../../../models/ErrorHelper';
import { ModelHelpers } from '../../../models/ModelHelpers';
import { PSTasacionModel } from '../../../models/ps-tasacion-model';
import { PsTasacionService } from '../../../services/ps-tasacion.service';
import { TasacionesService } from '../../../services/tasaciones.service';
import { ControlLookupComponent } from '../../control-lookup/control-lookup.component';
import { TasacionEditPsFormComponent } from '../../tasacion-edit/tasacion-edit-ps-form/tasacion-edit-ps-form.component';
import { TasacionesComponent } from '../../tasaciones/tasaciones.component';

@Component({
  selector: 'app-ps-asignacion-tasacion-form',
  templateUrl: './ps-asignacion-tasacion-form.component.html',
  styleUrls: ['./ps-asignacion-tasacion-form.component.scss']
})
export class PsAsignacionTasacionFormComponent implements OnInit {

  formGroup: FormGroup;
  idps: number;
  errorMessage: string = '';
  model: PSTasacionModel;

  @ViewChild('lookupPS', { static: false }) lookupPS: ControlLookupComponent;

  constructor(public dialogRef: MatDialogRef<TasacionEditPsFormComponent>, private _fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any, private _avRoute: ActivatedRoute, public matDialog: MatDialog, private _psTasacionService: PsTasacionService,
    private _tasacionesService: TasacionesService) {
    if (data !== null) {
      this.idps = data.id;
    }
  }

  ngOnInit() {
    this.buildForm();
  }

  ngAfterViewInit(): void {
    if (this.lookupPS) {
      this.lookupPS.serviceSource = (query: string) => {
        return this._tasacionesService.getTasacionesLookup(query);
      };
      this.lookupPS.serviceSourceById = (id: number) => {
        if (id != null) {
          return this._tasacionesService.getTasacionesLookupId(id);
        }
      };

      this.lookupPS.advancedLookupComponent = TasacionesComponent;
    }
  }

  buildForm() {
    if (this.model === undefined) this.model = new PSTasacionModel();
    this.formGroup = this._fb.group({
      id: 0,
      idps: [this.idps],
      tasacionId: null
    })
  }

  bindToModel() {
    ModelHelpers.copyFromForm(this.formGroup.value, this.model);
  }

  async onSubmit() {
    let result = null;

    if (!this.formGroup.valid)
      return

    this.bindToModel();

    if (this.idps != 0) {
      if (this.formGroup.value != null) {
        try {
          await this._psTasacionService.post(this.model).toPromise()
          result = true;
          this.closeDialog();
        } catch (error) {
          result = false;
          let errorMessage = ErrorHelper.GetClientError(error);
          this.errorMessage = errorMessage;
        }
      }
    }
    return result;
  }

  closeDialog() {
    this.dialogRef.close(true);
  }
}